import React from 'react';

/**
 * Reusable component for displaying locked feature UI for trial users
 * Can be displayed inline or as a modal overlay
 *
 * @param {string} featureName - Name of the locked feature (e.g., "AI Mock Interviews")
 * @param {boolean} showAsInline - If true, displays inline; if false, displays as centered modal
 */
const LockedFeatureModal = ({ featureName = 'This feature', showAsInline = true }) => {
  const content = (
    <div className="text-center max-w-md">
      <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
        <img src="/thinkingcar.png" alt="Locked feature" className="w-16 h-16" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{featureName} Locked</h3>
      <p className="text-gray-600 mb-4">
        Your Basic Trial doesn't include {featureName}. Contact support@internhubapp.com if you
        think this is a mistake!
      </p>
    </div>
  );

  if (showAsInline) {
    // Inline display - used inside existing containers
    return <div className="flex items-center justify-center p-8">{content}</div>;
  }

  // Modal overlay display - used as a standalone modal
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8">{content}</div>
    </div>
  );
};

export default LockedFeatureModal;
